// Static configuration for the Locations admin page.

export const DAYS_OF_WEEK = [
  'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday',
];

export const DEFAULT_OPERATING_HOURS = {
  monday: { open: '08:00', close: '22:00', closed: false, breaks: [] },
  tuesday: { open: '08:00', close: '22:00', closed: false, breaks: [] },
  wednesday: { open: '08:00', close: '22:00', closed: false, breaks: [] },
  thursday: { open: '08:00', close: '22:00', closed: false, breaks: [] },
  friday: {
    open: '08:00', close: '22:00', closed: false,
    breaks: [{ start: '12:00', end: '14:00', reason: 'Friday Prayer' }],
  },
  saturday: { open: '09:00', close: '23:00', closed: false, breaks: [] },
  sunday: { open: '09:00', close: '21:00', closed: false, breaks: [] },
};

export const AVAILABLE_AMENITIES = [
  'Parking', 'Changing Rooms', 'Showers', 'Pro Shop', 'Cafeteria',
  'Vending Machines', 'Lockers', 'WiFi', 'Air Conditioning', 'Spectator Seating',
];

export const DEFAULT_FORM_DATA = Object.freeze({
  name: '',
  address: '',
  city: '',
  postal_code: '',
  phone: '',
  email: '',
  notification_email: '',
  bank_name: '',
  bank_account: '',
  courts_count: 5,
  operating_hours: DEFAULT_OPERATING_HOURS,
  sports: ['badminton', 'pickleball'],
  amenities: [],
  description: '',
  active: true,
});

export const formatDayName = (day) => day.charAt(0).toUpperCase() + day.slice(1);
